const drop = document.querySelector('.collapsible-tab__embellishment');
const dropWrap = drop.querySelector('#embellishment');
const button = drop.querySelector('.collapsible-tab__btn-text');
const buttonText = drop.querySelector('.collapsible-tab__btn-text');
const items = drop.querySelectorAll('.collapsible-tab__drop span');
const input = document.querySelector('.line-item-property__field input');


items.forEach(function(item) {
  item.addEventListener('click', function(event) {
    const btn =  event.target;
    const text = btn.innerText;


    buttonText.innerText = text;
    input.value = text;

    button.click()
  });
});